import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { ettsBootstrap } from "@/lib/bootstrap";
import { setApiLocale } from "@/lib/apiClient";
import cs from "./locales/cs.json";
import sk from "./locales/sk.json";
import en from "./locales/en.json";

/**
 * i18next — bundly cs/sk/en (`./locales/*.json`), postupně seedované z
 * server-side `messages*.properties`. Počáteční locale ze server-injected
 * bootstrapu (`window.__ETTS__.locale`), fallback cs.
 *
 * Změna jazyka se perzistuje server-side přes POST `/admin/api/v1/locale`
 * (viz `lib/locale.ts`), aby se sladila s texty renderovanými backendem.
 */
const SUPPORTED = ["cs", "sk", "en"] as const;
const initial = SUPPORTED.includes(ettsBootstrap().locale as (typeof SUPPORTED)[number])
  ? ettsBootstrap().locale
  : "cs";

void i18n.use(initReactI18next).init({
  resources: {
    cs: { translation: cs },
    sk: { translation: sk },
    en: { translation: en },
  },
  lng: initial,
  fallbackLng: "cs",
  interpolation: { escapeValue: false },
});

setApiLocale(i18n.language);
i18n.on("languageChanged", (lng) => setApiLocale(lng));

export default i18n;
